import { getElementChild, getElements } from '../Utility/Dom'

class HeaderSearch {
  private readonly items: NodeListOf<HTMLElement>

  constructor() {
    this.items = getElements('header-search')
  }

  public init(): void {
    if (this.items.length === 0) return

    this.items.forEach((item: HTMLElement): void => {
      const button: HTMLElement | null = getElementChild(item, 'header-search-button')
      const wrap: HTMLElement | null = getElementChild(item, 'header-search-wrap')

      if (button === null || wrap === null) return

      this.addEvents(item, button, wrap)
    })
  }

  private addEvents(item: HTMLElement, button: HTMLElement, wrap: HTMLElement): void {
    button.addEventListener('click', (): void => {
      button.setAttribute('aria-expanded', this.isExpanded(button) ? 'false' : 'true')
      const searchInput: HTMLElement = getElementChild(item, 'search-input')

      if (this.isExpanded(button) === true) {
        searchInput?.focus({ preventScroll: true })
      }
    })

    document.addEventListener('keydown', (event: KeyboardEvent): void => {
      if (event.key === 'Escape' && this.isExpanded(button)) {
        this.close(button)
      }
    })

    document.addEventListener('click', (event: MouseEvent): void => {
      const target = event.target as HTMLElement

      if (
        this.isExpanded(button) === true &&
        target !== button &&
        wrap.contains(target) === false
      ) {
        this.close(button)
      }
    })
  }

  private close(button: HTMLElement): void {
    button.setAttribute('aria-expanded', 'false')
    button.focus({ preventScroll: true })
  }

  private isExpanded(button: HTMLElement): boolean {
    return button.getAttribute('aria-expanded') === 'true'
  }
}

const headerSearch = new HeaderSearch()
headerSearch.init()
